import { Injectable } from '@angular/core';

import { filter, take, tap } from 'rxjs/operators';

import { FallbackService } from '@lib-core/fallback/services/fallback.service';
import { LayoutCoreSplashscreenService } from '@lib-core/layout/services/layout-core-splashscreen.service';
import { LayoutCoreService } from '@lib-core/layout/services/layout-core.service';
import { GmapService } from '@lib-shared/gmap/services/gmap.service';
import { PwaService } from '@lib-shared/pwa/services/pwa.service';
import { GlobalStoreService } from '../../global/services/global-store.service';

@Injectable({
  providedIn: 'root',
})
export class BootService {
  /**
   * constructor
   *
   */
  constructor(
    private globalStoreService: GlobalStoreService,
    private layoutCoreService: LayoutCoreService,
    private layoutCoreSplashscreenService: LayoutCoreSplashscreenService,
    private fallbackService: FallbackService,
    private gmapService: GmapService,
    private pwaService: PwaService,
  ) {}

  /**
   * onAppConstruct
   *
   */
  onAppConstruct(): void {
    // init fallback
    this.fallbackService.init();

    // restore local storage global
    this.globalStoreService.restoreLocalStorage();

    // load gmap library
    this.gmapService.loadLibrary();

    // subscribe to layoutCoreSplashscreenService.isAnimationCompleted$
    this.layoutCoreSplashscreenService.isAnimationCompleted$
      .pipe(
        filter((isCompleted) => isCompleted),
        take(1),
        tap(() => {
          this.globalStoreService.initOnSplashscreenCompleted();
        }),
      )
      .subscribe();

    // init global
    this.globalStoreService.init();

    // init layoutCoreSplashscreenService
    this.layoutCoreSplashscreenService.init();

    // init layoutCoreService
    this.layoutCoreService.init();

    this.pwaService.init();
  }

  /**
   * onAppInit
   *
   */
  onAppInit(): void {}

  /**
   * onAppAfterViewInit
   *
   */
  onAppAfterViewInit(): void {
    // init global after view
    this.globalStoreService.initAfterView();
  }
}
